/* ------------------------------------------------------------------------------
 *
 *  # Navigation Module
 *
 *  Navigation functionality
 *
 * ---------------------------------------------------------------------------- */

// Sidebar navigation
export function navigationSidebar() {
    // Elements
    const navContainerClass = 'nav-sidebar',
        navItemOpenClass = 'nav-item-open',
        navLinkClass = 'nav-link',
        navLinkDisabledClass = 'disabled',
        navSubmenuContainerClass = 'nav-item-submenu',
        navSubmenuClass = 'nav-group-sub',
        navScrollSpyClass = 'nav-scrollspy',
        sidebarNavElement = document.querySelectorAll(`.${navContainerClass}:not(.${navScrollSpyClass})`);

    // Setup
    sidebarNavElement.forEach(function (nav) {
        nav.querySelectorAll(`.${navSubmenuContainerClass} > .${navLinkClass}:not(.${navLinkDisabledClass})`).forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const submenuContainer = link.closest(`.${navSubmenuContainerClass}`);
                const submenu = link.closest(`.${navSubmenuContainerClass}`).querySelector(`:scope > .${navSubmenuClass}`);

                // Collapsible
                if (submenuContainer.classList.contains(navItemOpenClass)) {
                    new bootstrap.Collapse(submenu).hide();
                    submenuContainer.classList.remove(navItemOpenClass);
                }
                else {
                    new bootstrap.Collapse(submenu).show();
                    submenuContainer.classList.add(navItemOpenClass);
                }

                // Accordion
                if (link.closest(`.${navContainerClass}`).getAttribute('data-nav-type') == 'accordion') {
                    for (let sibling of link.parentNode.parentNode.children) {
                        if (sibling != link.parentNode && sibling.classList.contains(navItemOpenClass)) {
                            sibling.querySelectorAll(`:scope > .${navSubmenuClass}`).forEach(function (submenu) {
                                new bootstrap.Collapse(submenu).hide();
                                sibling.classList.remove(navItemOpenClass);
                            });
                        }
                    }
                }
            });
        });
    });
}
